import React from 'react'
import Modal from '../../../../common/Modal'
import { Button } from '../../../../common/index'
import { Booklet } from '../../../../types/generated.types'

interface CalculationModalProps {
  isOpen: boolean
  closeModal: () => void
  selectedBooklet?: Booklet
  isMainAssociation: boolean
}

const CalculationModal: React.FC<CalculationModalProps> = ({
  isOpen,
  closeModal,
  selectedBooklet,
  isMainAssociation
}) => {
  // Beräkna generella värden för systemet (inte personlig förtjänst)
  const totalCommission = selectedBooklet?.totalCommission || 0;
  const supportCommissionToAssociation = selectedBooklet?.supportCommissionToAssociation || 0;
  const supportCommissionToMainAssociation = selectedBooklet?.supportCommissionToMainAssociation || 0;

  // Vad FÖRENINGEN får från återförsäljning
  const associationResellerEarnings = isMainAssociation
    ? supportCommissionToMainAssociation  // Huvudförening får stödandelen
    : 0;  // Vanlig förening får inget

  // Vad ÅTERFÖRSÄLJAREN får
  const resellerEarnings = totalCommission - supportCommissionToMainAssociation;  // Alltid samma

  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      className="modal-calculation"
    >
      <h2 className="modal-title">Hur räknar vi?</h2>

      <div className="calculation-section">
        <h3>Er förtjänst per häfte</h3>
        <p className="section-description">
          Så här mycket pengar går till er per sålt häfte,
          beroende på om det är ni som säljer häftet (Direkt försäljning)
          eller om det är en av era återförsäljare (Via återförsäljare).
        </p>

        <div className="calculation-stats">
          {isMainAssociation
            ? <div className='direct-sales'>
              <div className="calc-stat-box">
                <div className="calc-stat-label">Direkt försäljning</div>
                <div className="calc-stat-value">
                  <span>{totalCommission}</span>
                  <span>kr</span>
                </div>
              </div>
              <div className="calc-stat-box">
                <div className="calc-stat-label">Varav andel går till förening vald vid köp i webbshop.</div>
                <div className="calc-stat-value">
                  <span>- {supportCommissionToAssociation}</span>
                  <span>kr</span>
                </div>
              </div>
            </div>
            : <>
              <div className="calc-stat-box">
                <div className="calc-stat-label">Direkt försäljning</div>
                <div className="calc-stat-value">
                  <span>{totalCommission - supportCommissionToMainAssociation}</span>
                  <span>kr</span>
                </div>
              </div>
            </>
          }
          <div className="calc-stat-box">
            <div className="calc-stat-label">Via återförsäljare</div>
            <div className="calc-stat-value">
              <span>{associationResellerEarnings}</span>
              <span>kr</span>
            </div>
          </div>
        </div>
      </div>

      <div className="calculation-section">
        <h3>Återförsäljarens förtjänst per häfte</h3>
        <p className="section-description">
          Så här mycket pengar går till återförsäljaren
          per häfte som återförsäljaren har sålt.
        </p>

        <div className="calculation-stats single">
          <div className="calc-stat-box">
            <div className="calc-stat-label">Via återförsäljare</div>
            <div className="calc-stat-value">
              <span>{resellerEarnings}</span>
              <span>kr</span>
            </div>
          </div>
        </div>
      </div>

      <div className="calculation-section">
        <h3>Bonus</h3>
        <p className="section-description">
          Ev. volymbaserad bonus tillkommer efter avslutad
          försäljning.
        </p>
      </div>

      <div className="modal-actions">
        <Button className="primary alt md" onClick={closeModal}>Stäng</Button>
      </div>
    </Modal>
  )
}

export default CalculationModal
